import { TIPOS_LOTE, tipoLote } from '../events/util';

// Filtro de tipo arriba del selector de lote.
//
// Con ingreso general, VIP, los combos de 6 localidades y los traslados sueltos de otras
// 6, elegir el lote es buscar en una lista de 15. Esto la parte en tres.
//
// Solo aparecen los tipos que EXISTEN en el evento: en una noche sin micro, ofrecer
// "Combos" y "Traslados" vacíos es ruido. Y si hay un solo tipo, el filtro no se dibuja.
export default function FiltroTipoLote({ lotes, valor, onChange }) {
  const presentes = TIPOS_LOTE.filter(([k]) => (lotes || []).some(l => tipoLote(l) === k));
  if (presentes.length < 2) return null;
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
      {[['todos', 'Todos'], ...presentes].map(([k, t]) => (
        <button key={k} type="button"
          className={'lb-btn lb-btn--sm ' + (valor === k ? 'lb-btn--white' : 'lb-btn--ghost')}
          onClick={() => onChange(k)}>{t}</button>
      ))}
    </div>
  );
}

// Aplica el filtro. Vive con el componente para que las dos pantallas que lo usan no
// puedan interpretarlo distinto.
export function filtrarPorTipo(lotes, valor) {
  if (!valor || valor === 'todos') return lotes || [];
  return (lotes || []).filter(l => tipoLote(l) === valor);
}

// Con qué tipo arranca el filtro. Ingresos es lo que más se genera, así que va primero;
// pero si el evento no tiene ninguno —una noche que solo vende combos— arranca en el
// primero que exista, para no abrir con una lista vacía.
export function tipoInicial(lotes) {
  const hay = (k) => (lotes || []).some(l => tipoLote(l) === k);
  if (hay('ingreso')) return 'ingreso';
  const primero = TIPOS_LOTE.find(([k]) => hay(k));
  return primero ? primero[0] : 'todos';
}
